import { useFamilies } from '@hooks/useFamilies';
import { useProducts } from '@hooks/useProducts';
import { NavigatorContext } from 'provider/Navigator.provider';
import React from 'react';
import {
  Family, FamilyProducts,
  FamilyTitle
} from './Family';
import { Product } from './Product';

export const Families = () => {
  const { families } = useFamilies();
  const { products } = useProducts();
  const { selectedFamily } = React.useContext(NavigatorContext);

  return (
    <React.Fragment>
      {families &&
        families
          .filter(
            (fam) => selectedFamily === 'all' || selectedFamily === fam.uuid
          )
          .map((family) => (
            <Family key={family.uuid}>
              <FamilyTitle>{family.name}</FamilyTitle>
              <FamilyProducts>
                {products &&
                  products
                    .filter((p) => p.family == family.uuid)
                    .map(
                      (product, index, arr) =>
                        product.isActive && (
                          <Product
                            key={product.uuid}
                            product={product}
                            hasLine={index !== arr.length - 1}
                          />
                        )
                    )}
              </FamilyProducts>
            </Family>
          ))}
    </React.Fragment>
  );
};
